function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 17.0992V20.0992H9.9L15.8 14.1992L12.8 11.1992L7 17.0992ZM14.2 14.1992L9.5 18.8992H8.2V17.4992L12.8 12.7992L14.2 14.1992Z",
  fill: "#00AAFF"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1008 8L13.8008 10.3L16.8008 13.3L19.1008 10.9L16.1008 8ZM16.7008 11.6L15.5008 10.3L16.1008 9.7L17.4008 11L16.7008 11.6Z",
  fill: "#00AAFF"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 3.1,
  stroke: "#00AAFF",
  strokeWidth: 0.8
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.44922 9.8988C7.44922 9.8988 9.54922 10.9488 9.54922 9.5488C9.54922 8.28685 7.44922 8.90559 7.44922 7.7988C7.44922 6.7488 8.84922 6.74881 9.54922 7.44881",
  stroke: "#00AAFF",
  strokeWidth: 0.7,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 10.5996L8.5 6.39961",
  stroke: "#00AAFF",
  strokeWidth: 0.7,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgChangeSumIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChangeSumIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/change-sum-icon.da2aa32b.svg";
export { ForwardRef as ReactComponent };